import { combineReducers } from "redux";

import authReducer from "./authReducer";
import statusReducer from "./statusReducer";
import userReducer from "./userReducer";
import catalogReducer from "./catalogReducer";
import cartReducer from "./cartReducer";
import creditReducer from "./creditReducer";
import orderReducer from "./orderReducer";
import paymentReducer from "./paymentReducer";
import registerReducer from "./registerReducer";
import happyRegisterReducer from "./happyRegisterReducer";
import aerobars from "./aerobars";
import acquisitionRail from "./acquisition";
import downloadDaApp from "./downloadDaApp";
import toast from "./toastReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  status: statusReducer,
  user: userReducer,
  catalog: catalogReducer,
  cart: cartReducer,
  credit: creditReducer,
  order: orderReducer,
  payment: paymentReducer,
  register: registerReducer,
  happyRegister: happyRegisterReducer,
  aerobars: aerobars,
  acquisitionRail: acquisitionRail,
  downloadDaApp: downloadDaApp,
  toast: toast,
});

export default rootReducer;
